import { Controller } from "@hotwired/stimulus"

// 성상(phase)이 '고체' 또는 '액체'일 때만 표시되는 row (분사/스프레이 여부)를 토글
// 사용 예:
//   <div data-controller="phase-toggle">
//     <div data-action="change->phase-toggle#update"> <!-- phase radio group --> </div>
//     <div data-phase-toggle-target="sprayable"> <!-- 분사/스프레이 전용 row --> </div>
//   </div>
export default class extends Controller {
  static targets = ["sprayable"]

  update(event) {
    const radio = event.target
    if (radio.type !== "radio") return
    if (!/\[phase\]$/.test(radio.name)) return

    // 라디오가 deselect(두 번 클릭)된 경우에도 change 이벤트가 발생하지만
    // 이때는 radio.checked === false. 체크된 상태에서만 표시 판정한다.
    const show = radio.checked && (radio.value === "solid" || radio.value === "liquid")
    this.sprayableTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      // 숨길 때는 내부 checkbox 값 초기화 (데이터 정합성)
      if (!show) {
        el.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false })
      }
    })
  }
}
